import styles from './QuickItem.module.css';
interface QuickDescriptionPropsText {
  text: string;
}
export function QuickDescriptionText({
  text,
}: Readonly<QuickDescriptionPropsText>) {
  return <div className={styles.text_content}>{text}</div>;
}
